// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
	<meta name="p:domain_verify" content="bbf570ef2eebb947eaf94a8190aadc3f"/>
	

});